interface LeelooUser {
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  user_uuid: string;
  rise_works_status: string;
  rise_works_invited: string; // ISO date string
  rise_works_confirmed: string; // ISO date string
}

interface LeelooAccount {
  account_uuid: string;
  qualify_pa_account_package_id: number;
  qualify_pa_account_package_date: string; // ISO date string
  is_weekly_payout: boolean;
  rithmic_account_name: string;
  created_at: string; // ISO date string
}

interface PAProduct {
  id: number;
  title: string;
}

interface PAAccount {
  account_uuid: string;
  qualify_pa_account_package_id: number;
  qualify_pa_account_package_date: string; // ISO date string
  is_weekly_payout: boolean;
  rithmic_account_name: string;
  created_at: string; // ISO date string
}

export interface PaAccountProcess {
  stage1_complete: boolean;
  stage2_complete: boolean;
  stage3_complete: boolean;
  our_website: string;
  leeloo_user: LeelooUser;
  leeloo_account: LeelooAccount;
  pa_product: PAProduct;
  pa_account: PAAccount;
}

export enum PaPaymentMode {
  SUBSCRIPTION = 'subscription',
  ONETIME = 'onetime',
}

export type CheckoutPayload = {
  leeloo_user_uuid: string;
  leeloo_account_uuid: string;
  payment_mode: PaPaymentMode;
  payment_gateway: string;
  package_id?: number;
  user_checkout_id?: number;
  billing_info: {
    street: string;
    city: string;
    country: string;
    state?: string;
    zip_code?: string;
    phone_number: string;
    first_name: string;
    last_name: string;
  };
};
